// Dev-only logging helpers. In production these become no-ops so we
// keep useful debug output during development without leaking noise to
// end users. Silent-catch bugs are still preserved because we log in dev.
const isDev = process.env.NODE_ENV !== "production";

export const devWarn = (...args) => {
  if (isDev) console.warn(...args);
};

export const devError = (...args) => {
  if (isDev) console.error(...args);
};
